module.exports = {"applyButtonText":"Abos anzeigen","defaultPlaceholder":"Treffen Sie Ihre Wahl"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/de/product-filter.json
// module id = KJlw
// module chunks = 1